import { useState, useEffect, useRef } from "react";

const PING_URL = `${process.env.REACT_APP_API_URL}/ticketing/ticket_insights`;
const PING_INTERVAL = 15000;

const useNetworkStatus = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const intervalRef = useRef(null);

  const checkConnectivity = async () => {
    try {
      await fetch(PING_URL, { method: "HEAD", cache: "no-store", signal: AbortSignal.timeout(5000) });
      setIsOnline(true);
    } catch {
      setIsOnline(false);
    }
  };

  useEffect(() => {
    const goOnline = () => {
      setIsOnline(true);
      checkConnectivity();
    };
    const goOffline = () => setIsOnline(false);

    window.addEventListener("online", goOnline);
    window.addEventListener("offline", goOffline);

    intervalRef.current = setInterval(checkConnectivity, PING_INTERVAL);

    return () => {
      window.removeEventListener("online", goOnline);
      window.removeEventListener("offline", goOffline);
      clearInterval(intervalRef.current);
    };
  }, []);

  return isOnline;
};

export default useNetworkStatus;
